import React from 'react';
import {
  ArrowPathIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';

interface RemoveTenantModalProps {
  isOpen: boolean;
  tenantName: string;
  onClose: () => void;
  onConfirm: () => void;
  removing?: boolean;
}

const RemoveTenantModal: React.FC<RemoveTenantModalProps> = ({
  isOpen,
  tenantName,
  onClose,
  onConfirm,
  removing = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white shadow-2xl">
        <div className="border-b border-gray-100 px-6 py-4">
          <h3 className="text-xl font-bold text-gray-900">Remove Tenant</h3>
          <p className="text-sm text-gray-500">
            This will remove {tenantName} from this property.
          </p>
        </div>
        <div className="px-6 py-6">
          <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 mb-6">
            <div className="flex gap-3">
              <ExclamationTriangleIcon className="h-6 w-6 text-amber-600 flex-shrink-0" />
              <div>
                <p className="text-sm font-semibold text-amber-900">
                  Are you sure?
                </p>
                <p className="text-sm text-amber-700 mt-1">
                  This action will remove the tenant from this property. This
                  cannot be undone.
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={removing}
              className="inline-flex items-center gap-2 rounded-xl bg-red-600 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-red-500/40 transition hover:scale-[1.01] disabled:opacity-50"
            >
              {removing && <ArrowPathIcon className="h-4 w-4 animate-spin" />}
              Remove Tenant
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveTenantModal;
